import isEmpty from "lodash/isEmpty";
import classNames from "classnames";
import WeaTimePicker from "../wea-time-picker";
import middleware from "../../middleware";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startValue: "",
      endValue: ""
    };
    if (!isEmpty(props.value)) {
      if (props.value[0] !== undefined) this.state.startValue = props.value[0];
      if (props.value[1] !== undefined) this.state.endValue = props.value[1];
    }
  }
  componentWillReceiveProps(nextProps) {
    if ("value" in nextProps) {
      let startValue = "",
        endValue = "";
      if (!isEmpty(nextProps.value)) {
        startValue = nextProps.value[0];
        endValue = nextProps.value[1];
      }
      this.setState({ startValue, endValue });
    }
  }
  onChangeL(value) {
    this.setState({ startValue: value });
    const { endValue = "" } = this.state;
    let resp = [value, endValue];
    if (!value && !endValue) resp = [];
    this.props.onChange && this.props.onChange(resp);
  }
  onChangeR(value) {
    this.setState({ endValue: value });
    const { startValue = "" } = this.state;
    let resp = [startValue, value];
    if (!value && !startValue) resp = [];
    this.props.onChange && this.props.onChange(resp);
  }
  isEmpty(v) {
    return v === "" || v == null;
  }
  render() {
    const { startValue, endValue } = this.state;
    const { noInput, needDivision = true, className = "", style } = this.props;
    const cStyle = {};
    const viewAttr = this.props.viewAttr;
    let { props } = this;
    if (viewAttr == "3") delete props.viewAttr;
    if (!noInput) cStyle.width = 100;
    const req = classNames({
      [`${className}`]: className,
      required:
        viewAttr == "3" && (this.isEmpty(startValue) || this.isEmpty(endValue))
    });
    return (
      <div className={`wea-scope ${req}`} style={style}>
        <WeaTimePicker
          style={cStyle}
          {...props}
          value={startValue}
          onChange={this.onChangeL.bind(this)}
        />
        <span style={{ padding: "0 4px" }}>{needDivision && "-"}</span>
        <WeaTimePicker
          style={cStyle}
          {...props}
          value={endValue}
          onChange={this.onChangeR.bind(this)}
        />
        {/* {viewAttr == "3" &&
          (this.isEmpty(startValue) || this.isEmpty(endValue)) && (
            <span className="wea-required-e9">
              <img src="/images/BacoError_wev9.png" align="middle" />
            </span>
          )} */}
      </div>
    );
  }
}

const Com = middleware(Main, "WeaTimeRangePicker");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-time-range-picker/index.js